<script>
	import axios from "axios"
	import { onMount } from 'svelte'
	import localMenuData from "./menuData.json";
	$: innerWidth = 0
	let displayCategories = false
	const url = 'https://carlo-web.herokuapp.com/api/accounts'

	let menuData = localMenuData

	onMount(async () => {
		try {
			let res = await axios.get(url, {params: {getType: "getBusinessDataOf", businessName: "Gyro Plus"}})
			menuData = res.data.businessData.menu
			console.log(res.data.msg)

		} catch(err) {
			console.log(err)
		}
	})

	const mcToggle = () => {
		displayCategories = !displayCategories
	}

	let displayedCategory = 0
	const changeCategory = (index) => {
		displayedCategory = index
		displayCategories = false
	}
</script>

<svelte:window bind:innerWidth />

<main>
	<header class="py-5">
		<div class="title my-2 mb-4">
			<h1 class="title-text my-0 me-3"><strong>
				<span class="title-gyro">Gyro<span/> <span class="title-plus">Plus</span>
			</strong></h1>
			<img class="logo-image" src="gyropluslogonotext.png" alt="Gyro">
		</div>
		<h4 class="phone-number"><a href="tel:3523365323">(352) 336-5323</a></h4>
		<address>
			<h4 class=""><a target="_blank" and rel="noopener noreferrer" href="https://goo.gl/maps/RU3PW9xjWJwV444F7">2409 SW 13th St, Gainesville, FL</a></h4>
		</address>
		<h4 class="">Dine In or Carry Out from 11:00AM - 9:00PM, Closed Sunday</h4>
	</header>
	<!--<div class="gallery d-flex">
		<div class="site-image">
			<span>Gyro Wrap</span>
			<img src="Gyro Wrap.jpg" alt="Gyro Wrap"/>
		</div>
		<div class="site-image">
			<span>Dinner Plate</span>
			<img src="Dinner Plate.jpg" alt="Dinner Plate"/>
		</div>
	</div>-->
	<div class="p-3 menu">
		<h1 class="p-4 menu-title">Menu</h1>
		<div class="menu-not-the-part-that-says-menu">
			<div class="menu-category-titles">
				{#if innerWidth < 700}
				<h2 class="mc-toggle pt-1 pb-2 px-3 my-1" on:click={mcToggle}>
					{#if displayCategories == true}Collapse Categories <img class="mc-expand" src="expand-arrow-up.png" alt="Expand Arrow">{/if}
					{#if displayCategories == false}View Categories <img class="mc-expand" src="expand-arrow-down.png" alt="Expand Arrow">{/if}
				</h2>
				{/if}
				{#if displayCategories == true || innerWidth > 699}
					{#each menuData as data}
						<button class="mc-title p-1 pb-2 mt-1 {displayedCategory === menuData.indexOf(data) ? 'selected' : ''}" on:click={() => changeCategory(menuData.indexOf(data))}>
							<h2 class="mb-0">{data.categoryTitle}</h2>
						</button>
					{/each}
				{/if}
			</div>
			<div class="menu-category-contents">
				{#if innerWidth < 701}
					<h2 class="mc-mobile-title pt-4 mb-0">{menuData[displayedCategory].categoryTitle}</h2>
				{/if}
				{#if menuData[displayedCategory].description != undefined && menuData[displayedCategory].description != ""}
					<span>{menuData[displayedCategory].description}</span>
					<hr>
				{/if}
				<div class="mc-item-list">
					{#each menuData[displayedCategory].items as data}
							<div class="mc-item">
								<h3>{data.name}</h3>
								<span>{data.description} {data.price}</span>
								{#if data.vegan} <img src="veganSm.png" alt="Vegan"> {/if}
							</div>
					{/each}
				</div>
			</div>
		</div>
	</div>
</main>

<style>
	@font-face{
		font-family: thefontimusing;
		src: url(../fonts/MavenPro-Regular.ttf);
		font-weight: normal;
		font-style: normal;
	}
	@font-face{
		font-family: thefontimusing;
		src: url(../fonts/MavenPro-Bold.ttf);
		font-weight: bold;
		font-style: normal;
	}
	.gallery {
		margin-bottom: 20px;
		margin-top: 20px;
		margin-inline: max(10%,50% - 700px/2);
	}
	.site-image {
        display: flex;
        align-items: center;
        justify-content: center;
		margin-bottom: 18px !important;
		flex-grow: 1;
		margin: 2%;
	}
	.site-image > img {
		object-fit: cover;
        max-width: 100%;
        min-height: 100%;
        min-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
		z-index: -1;
		transition: .3s all;
		border: 1px black solid;
		z-index: 1;
	}
	.site-image:hover > img {
		transform: scale(1.04);
		opacity: 50%;
		z-index: -1;
	}
	.site-image > span {
		position: absolute;
		color: black;
		font-size: 1.5em;
	}

	main {
		text-align: center;
		margin: 0 auto;
	}


	header {
		font-family: thefontimusing;
		background: black;
		color: #F3F3F3;
		width: 100%;
	}
	
	h1 {
		text-transform: uppercase;
		font-size: 5em;
	}

	h2 {
		font-size: 2em;
	}

	h3 {
		padding-top: 1em;
	}

	h4 > a {
		text-decoration: none;
		color: #F3F3F3;
		transition: all .3s;
	}

	h4 > a:hover{
		color: #405ac9;
	}

	header > address {
		margin: auto;
	}

	.title-text {
		display: inline-block;
		vertical-align: middle;
		font-family:Georgia, serif;
	}

	.title-gyro {
		color: #405ac9;
	}
	.title-plus {
		color: #ec8529;
	}
    /*EF233C*/

	.logo-image {
		display: inline-block;
		width: 110px;
		height: auto;
		vertical-align: middle;
	}

	.menu {
		text-align: center;
		margin: 0 auto;
		font-family: thefontimusing;
		background: #F3F3F3;
	}

	 /*menu takes up not the whole screen on larger window*/
	@media (max-width: 1649px) {
		.menu {
			max-width: 100%
		}
	}

	@media (min-width: 1650px) {
		.menu {
			max-width: 80%
		}	
	}

	.menu-not-the-part-that-says-menu {
		display: flex;
	}


	@media (max-width: 1499px){
		.menu-category-titles {
			min-width: 300px;
			max-width: 300px;
		}
	}

	@media (min-width: 1500px) {
		.menu-category-titles {
			min-width: 400px;
			max-width: 400px;
		}
	}

	.menu-category-contents {
		flex-grow: 1;
	}



	.menu-title {
		border-bottom: 1px solid black;
		padding: 0px 0px 20px 0px !important;
		margin-bottom: 15px;
	}

	.mc-toggle:hover {
		background: rgba(168, 218, 220, .4);
		transition: .3s all;
		cursor: pointer;
	}

	.mc-toggle {
		border: 2px black solid;
		width: fit-content;
		margin: auto;
	}

	.mc-expand {
		width: 23px;
		position: relative;
		transform: translateY(-5%);
	}

	.mc-title:nth-child(odd) {
		background: #ececec;
	}

	.mc-title {
		display: block;
		border: none;
		background: none;
	}

	.selected {
		border-left: 3px #ec8529 solid;
		font-weight: bold;
	}

	.mc-title:hover {
		background: rgba(186, 233, 233, 0.4);
		transition: .3s all;
		cursor: pointer;
	}

	.mc-title {
		transition: .3s all;
	}

	.mc-item-list {
		display: flex;
		justify-content: center;
		flex-direction: row;
		flex-flow: wrap;
		padding-bottom: 1em;
	}

	.mc-item > img {
		width: 25px;
		height: auto;
	}

	.mc-item {
		margin: .3em;
		padding: 6px;
		height: auto;
		text-align: center;
		border: 1px all black;
	}

	@media (min-width: 1398px) {
		.mc-item{
			width: 400px;
		}
	}
	@media (max-width: 1397px) {
		.mc-item{
			width: 100%;
		}
	}

	@media (min-width: 800px) {
		main {
			max-width: none;
		}
	}

	@media (max-width: 699px) {
		.menu-not-the-part-that-says-menu {
			display: block;
		}
		.menu-category-titles {
			margin: auto;
			min-width: 100%;
			max-width: 100%;
		}
		.mc-title {
			margin: auto;
			width: 75%;
		}
	}
	@media (min-width: 700px) {
		.mc-title {
			text-align: left;
			width: 90%;
		}
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>